import { render, staticRenderFns } from "./tariffCard.vue?vue&type=template&id=3e2623ae&scoped=true&"
import script from "./tariffCard.vue?vue&type=script&lang=js&"
export * from "./tariffCard.vue?vue&type=script&lang=js&"
import style0 from "./tariffCard.vue?vue&type=style&index=0&id=3e2623ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2623ae",
  null
  
)

export default component.exports